import { Galleria } from "primereact/galleria";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import banner3 from "../../../assets/images/home/banners/MULTISUOOUROCARd2.png";
import banner4 from "../../../assets/images/home/banners/Multiusocard1.png";
import { AdsPlaceHolder } from "../../../components/adsPlaceHolder";
import { Carrousel } from "../../../components/carrousel";
import { Loading } from "../../../components/loading";
import { ICarrossel } from "../../../Interfaces/model/iCarrossel";
import { IPublicidades } from "../../../Interfaces/model/IPublicidades";
import carrosselService from "../../../services/carrosselService";
import publicidadesService from "../../../services/publicidadesService";
import { findAdsByName, scrollUp } from "../../../utils/pageUtils";
import { CaroselWrapper, HomeContainer, PositionAds } from "./styles";

export const InitContainers = () => {
  const galleria = useRef<Galleria>(null);
  const galleria2 = useRef<Galleria>(null);

  const navigate = useNavigate();

  const [isLoading] = useState<boolean>(false);
  const [carrouselNews, setCarrouselNews] = useState<ICarrossel[] | null>(null);
  const [home, setHome] = useState<IPublicidades | undefined>();

  const [selectedImage, setSelectedImage] = useState("");
  const itemTemplate = (item: string) => {
    return <img src={item} alt="" style={{ width: "100%", display: "block" }} />;
  };

  useEffect(() => {
    scrollUp();
    getAds();
    getCarrossel();
  }, []);

  async function getAds() {
    publicidadesService
      .getAllAds()
      .then((res) => {
        res && setHome(findAdsByName({ nome: "Home 1", array: res.data }));
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  async function getCarrossel() {
    carrosselService
      .getHomeCarrossel()
      .then((res) => {
        const normalizedItems: ICarrossel[] = (res.data as any[]).map(
          (item) => ({
            id: item?.id,
            slug: item?.slug,
            titulo: item?.titulo ?? "",
            texto: item?.subtitulo ?? item?.texto ?? "",
            imagem: item?.imagem ?? "",
          })
        );

        const validItems = normalizedItems.filter((item) =>
          Boolean(item.imagem?.trim())
        );

        setCarrouselNews(validItems);
      })
      .catch((err) => {
        console.error("Erro ao carregar o carrossel da home", err);
      });
  }

  const carrouselImageClick = (item: any) => {
    // Card de noticia: redireciona para a pagina da noticia correspondente.
    if (item?.slug) {
      navigate(`/noticia/${item.slug}`);
      return;
    }

    // Compatibilidade com itens legados (banners / links externos).
    if (item.imageBanner) {
      if (item.title?.includes("Cartão Afesp MultiusoCard Três em Um.")) {
        galleria2.current?.show();
      } else {
        setSelectedImage(item.imageBanner);
        galleria.current?.show();
      }
    } else if (item.routerLink) {
      if (item.routerLink.includes("afesptv")) {
        window.open(item.routerLink);
      } else {
        navigate(item.routerLink);
      }
    }
  };

  return (
    <HomeContainer>
      <Galleria
        ref={galleria}
        value={[selectedImage]}
        numVisible={1}
        style={{
          maxWidth: "920px",
          width: "100%",
          padding: "1rem",
          margin: "auto",
        }}
        circular
        fullScreen
        showThumbnails={false}
        item={itemTemplate}
      />
      <Galleria
        ref={galleria2}
        value={[banner4, banner3]}
        numVisible={1}
        style={{
          maxWidth: "920px",
          width: "100%",
          padding: "1rem",
          margin: "auto",
        }}
        fullScreen
        showItemNavigators
        showThumbnails={false}
        item={itemTemplate}
      />
      <Loading isLoading={isLoading} />
      {!isLoading && (
        <>
          <CaroselWrapper>
            {carrouselNews && carrouselNews.length > 0 && (
              <Carrousel
                newsList={carrouselNews}
                onImageClick={carrouselImageClick}
              />
            )}
          </CaroselWrapper>

          {home && carrouselNews && carrouselNews.length > 0 && (
            <PositionAds>
              <AdsPlaceHolder
                key={home.id}
                image={home.imagemWeb + ""}
                image2={home.imagemMobile + ""}
                link={home.linkUrl + ""}
              />
            </PositionAds>
          )}
        </>
      )}
    </HomeContainer>
  );
};
